$(document).on('click', '.l-sidemenu-toggle', function() {
  if($('.l-sidemenu-toggle').hasClass('l-sidemenu-toggle--disabled')) { return; }
  $('.l-sidemenu').addClass('l-sidemenu--show');
});

$(document).on('click', '.l-sidemenu-toggle__close', function() {
  $('.l-sidemenu').removeClass('l-sidemenu--show');
});